var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.49 21.26c-.41 0-.74-.33-.74-.74s.33-.75.74-.75.75.33.75.75-.33.74-.75.74zm13.58-11.15L13.9 6.94l5.17-5.17a6.37 6.37 0 00-2.56-.53c-3.45 0-6.25 2.8-6.25 6.25 0 .9.19 1.79.56 2.6l-8.91 8.82c-.88.88-.88 2.31 0 3.18.44.44 1.01.66 1.59.66s1.15-.22 1.59-.66l8.81-8.91c.81.37 1.7.56 2.6.56 3.45 0 6.25-2.8 6.25-6.25 0-.95-.3-1.86-.57-2.49l-5.11 5.11z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49 21.26c-.41 0-.74-.33-.74-.74s.33-.75.74-.75.75.33.75.75-.33.74-.75.74zm13.58-11.15L13.9 6.94l5.17-5.17a6.37 6.37 0 00-2.56-.53c-3.45 0-6.25 2.8-6.25 6.25 0 .9.19 1.79.56 2.6l-8.91 8.82c-.88.88-.88 2.31 0 3.18.44.44 1.01.66 1.59.66s1.15-.22 1.59-.66l8.81-8.91c.81.37 1.7.56 2.6.56 3.45 0 6.25-2.8 6.25-6.25 0-.95-.3-1.86-.57-2.49l-5.11 5.11z",
    fill: "#6e6e6e",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e90a0a",
    d: "M0 0h6.27v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26221e",
    d: "M6.27 0h1v24h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8600",
    d: "M6.98 0h6.46v24H6.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ae0000",
    d: "M13.44 0h4.22v24h-4.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0065b1",
    d: "M17.66 0h1v24h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008520",
    d: "M18.11 0H24v24h-5.89z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/wrench.a415cefe66a649f29f58fbb4c0dadc6c.svg";
export { ForwardRef as ReactComponent };